import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  private readonly _html = new BehaviorSubject<string>('');
  private _currentHtml = '';
  html$ = this._html.asObservable();


  constructor(
    private _http: HttpClient
    ) { }

  // private _url = 'http://localhost/selena/calculator/src/api/print.php';
  private _url = 'http://test.hybrid.pl/selena/calculator/api/print.php';


  set html(content: string) {
    this._currentHtml = content;
  }

  get html() {
    return this._currentHtml;
  }

  get url() {
    return this._url;
  }

  set url(data) {
   this._url = data;
  }

  print(data) {
    // const formData: any = new FormData();
    // formData.append("user_id", user_id);
    const form = document.createElement('form');

    form.setAttribute('action', this._url);
    form.setAttribute('target', '_blank');
    form.setAttribute('method', 'post');
    form.setAttribute('display', 'none');

    data = JSON.stringify(data);

    const input = document.createElement('input');
    input.setAttribute('name', 'data');
    input.setAttribute('type', 'text');
    input.setAttribute('value', data);

    form.appendChild(input);


    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);

    // return this._http.post<any>(this.url,formData)
  }
}
